//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

import slugify from 'slugify';

export default {
  props: {
    postId: {
        type: String,
        default: null
    },
    icon: {
        type: String,
        default: null
    }
  },
  computed: {
      randomNumber() {
          let num = Math.floor((Math.random() * 18) + 1);
          return num < 10 ? '00'+num : '0'+num;
      }
  },
  watch: {

  },
  components: {

  },
  data() {
    return { 
      
      story: null
     
    }
  },
  mounted() {

    let self = this;
    if ( this.postId ) {
        
        this.getPost(this.postId);
    }
   
 

  },
  methods: {
    getUrl(story) {
        return `#/post/${this.postId}`;
    },
    getImage(story) {
        return `https://api.everwondr.com${story.source}`;
    },
    urlTitle: function(post) {
      return post.id + '-' + slugify(post.title, { remove: /[*+~.()'"!,:@]/g });
    },
    printDate(dt, ps, fm) {
      return format( parse(dt, ps, new Date()), fm );
    },
    getPost(post_id) {

      post_id = slugify(post_id, { strict: true });
      let url = `https://api.everwondr.com/community/view_ajax/${post_id}`;

      $.ajax({
          url: url, // or example_ajax_obj.ajaxurl if using on frontend
          type: "GET",
          dataType: "json",
          success:(data) => {
              // This outputs the result of the ajax request
              console.log('story data', data)
              this.story = data.item;
          },
          error: function(errorThrown){
              console.log(errorThrown);
          }
      }); 

    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/StoryBlock.vue